import React from "react";
export const FCTextFieldContext = /*#__PURE__*/React.createContext({
  textFieldProps: {
    isDisabled: false,
    isInvalid: false,
    isReadOnly: false,
    isRequired: false
  }
});
//# sourceMappingURL=TextFieldContext.js.map